const GOOGLE_MAPS_LIBRARIES = ['places'];

const googleMapsLoaderConfig = {
  id: 'google-map-script',
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  libraries: GOOGLE_MAPS_LIBRARIES,
};

export default googleMapsLoaderConfig;
